'use client';

import { c as _c } from "react/compiler-runtime";
import useIsMounted from '@module/utils/useIsMounted';
import AdultSwitchButton from './AdultSwitchButton';
import BroadcastStartButton from './broadcast/BroadcastStartButton';
import DarkModeButton from './DarkModeButton';
import FanzaEntryLink from './FanzaEntryLink';
import MyNavMenuSSGContainer from './my-info/MyNavMenuSSGContainer';
import { NotificationMenu } from './notification/NotificationMenu';
import StoreButton from './StoreButton';
interface TopNavRightControlsProps {
  deferUntilMounted?: boolean;
  isCustomerPage?: boolean;
}
function TopNavRightControlsSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" className="flex flex-nowrap items-center"><div className="h-[48px] w-[48px]" /><div className="mr-[7px] h-[40px] w-[120px]" /><div className="h-[48px] w-[48px]" /><div className="h-[48px] w-[48px]" /><div className="h-[48px] w-[48px]" /><div className="mr-2 h-[28px] w-[28px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default function TopNavRightControls(t0) {
  const $ = _c(11);
  const {
    deferUntilMounted: t1,
    isCustomerPage
  } = t0;
  const deferUntilMounted = t1 === undefined ? false : t1;
  const isMounted = useIsMounted();
  if (deferUntilMounted && !isMounted) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <TopNavRightControlsSkeleton />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FanzaEntryLink />;
    t3 = <AdultSwitchButton />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isCustomerPage) {
    t4 = !isCustomerPage && <BroadcastStartButton>방송하기</BroadcastStartButton>;
    $[3] = isCustomerPage;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <StoreButton />;
    t6 = <NotificationMenu />;
    t7 = <DarkModeButton />;
    t8 = <MyNavMenuSSGContainer />;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4) {
    t9 = <div className="flex flex-nowrap items-center">{t2}{t3}{t4}{t5}{t6}{t7}{t8}</div>;
    $[9] = t4;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}